/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Genius_LedeInputs */

const tr_landing_genius_lede = /** @type {(inputs: Landing_Genius_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ShopPanel'i sadece araçlarla değil, gerçekten çalışan ajanlarla donattık. Her biri farklı bir iş yapar: müşteri sorularına yanıt önerir, ürün görseli üretir, fişleri okur ya da önemli olayları bildirir; ilk üçü yapay zeka ile çalışır. Kendi API anahtarınızı bağlayın veya ShopPanel AI kredilerini kullanın.`)
};

const en_landing_genius_lede = /** @type {(inputs: Landing_Genius_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We packed ShopPanel not just with tools, but with agents that actually work. Each one does a different job: it suggests replies to customer questions, creates product images, reads receipts or reports important events; the first three run on AI. Bring your own API key or use ShopPanel AI credits.`)
};

const de_landing_genius_lede = /** @type {(inputs: Landing_Genius_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wir haben ShopPanel nicht nur mit Werkzeugen ausgestattet, sondern mit Agenten, die wirklich arbeiten. Jeder übernimmt eine andere Aufgabe: Er schlägt Antworten auf Kundenfragen vor, erstellt Produktbilder, liest Belege oder meldet wichtige Ereignisse; die ersten drei arbeiten mit KI. Verbinden Sie Ihren eigenen API-Schlüssel oder nutzen Sie ShopPanel AI Credits.`)
};

const ru_landing_genius_lede = /** @type {(inputs: Landing_Genius_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мы оснастили ShopPanel не просто инструментами, а агентами, которые действительно работают. Каждый выполняет свою задачу: предлагает ответы на вопросы покупателей, создаёт изображения товаров, читает чеки или сообщает о важных событиях; первые три работают на ИИ. Подключите собственный API-ключ или используйте AI-кредиты ShopPanel.`)
};

/**
* | output |
* | --- |
* | "We packed ShopPanel not just with tools, but with agents that actually work. Each one does a different job: it suggests replies to customer questions, create..." |
*
* @param {Landing_Genius_LedeInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_genius_lede = /** @type {((inputs?: Landing_Genius_LedeInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Genius_LedeInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_genius_lede(inputs)
	if (locale === "de") return de_landing_genius_lede(inputs)
	if (locale === "ru") return ru_landing_genius_lede(inputs)
	return tr_landing_genius_lede(inputs)
});